__turbopack_context__.v({
  "paypal--button": "PYHpWG_paypal--button",
  "paypal--tagline": "PYHpWG_paypal--tagline",
  "paypal--wrapper": "PYHpWG_paypal--wrapper",
});
